module.exports = __webpack_public_path__ + "img/thermometer.dc8d157c.svg";